import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { TextInput } from '../components/text-input';
import { logInWithEmailAndPassword } from '../utils/firebase-config';
import { Header } from '../components/header';

import { LoginContainer, Form } from './styled-components';

export const Login = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const userAccessToken = localStorage.getItem('accessToken');
        const email = localStorage.getItem('email');
        const uid = localStorage.getItem('uid');
        if (userAccessToken && email && uid) navigate('/admin-space', { replace: true });
    }, []);

    const handleOnSubmit = (evt) => {
        evt.preventDefault();
        const data = new FormData(evt.target);
        if (data.get('email') && data.get('password')) {
            logInWithEmailAndPassword(data.get('email'), data.get('password'), navigate);
        } else {
            alert('Please enter email and password');
        }
    };

    return (
        <>
            <Header />
            <LoginContainer>
                <Form onSubmit={handleOnSubmit}>
                    <TextInput
                        labelName='EMAIL:'
                        name='email'
                        type='email'
                        id='email'
                        classes='login-input'
                    />
                    <TextInput
                        labelName='PASSWORD:'
                        name='password'
                        type='password'
                        id='password'
                        classes='login-input'
                    />
                    <button
                        type='submit'
                        className='login-btn'
                    >
                        Login
                    </button>
                </Form>
            </LoginContainer>
        </>
    );
};
